import { Icon } from '@eventbrite/eds-icon';
import {
    ChevronDownChunky,
    ChevronUpChunky,
} from '@eventbrite/eds-iconography';
import React from 'react';
import { DropdownContainerProps } from '../../../../types';
import { Dropdown } from '../Dropdown';
import styles from './DesktopDropdown.module.scss';

const DesktopDropdown = ({ dropdownItems, text }: DropdownContainerProps) => {
    return (
        <div className={styles.desktopDropdown} tabIndex={0}>
            <div className={styles.dropdownTitle}>
                <span>{text}</span>
                <span className={styles.arrowIcons}>
                    <Icon type={<ChevronUpChunky />} />
                    <Icon type={<ChevronDownChunky />} />
                </span>
            </div>
            <Dropdown dropdownItems={dropdownItems} />
        </div>
    );
};

export default DesktopDropdown;
